import { render, staticRenderFns } from "./CardInformation.vue?vue&type=template&id=6c2a8b39&scoped=true"
import script from "./CardInformation.vue?vue&type=script&lang=js"
export * from "./CardInformation.vue?vue&type=script&lang=js"
import style0 from "./CardInformation.vue?vue&type=style&index=0&id=6c2a8b39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2a8b39",
  null
  
)

export default component.exports